import { union } from 'lodash'
import { ScenarioQuestion } from '../model/scenario-question.model'

export enum ScopeConfigurationPromptStatus {
  DELETED = 'deleted',
  ADDED = 'added',
}

export const DEFAULT_FEE_VALUE = 'null'
export const PROMPT_SEPARATOR = '|'

export const getJoinedIdsString = (ids: number[] = []) => ids.join(',')

export const getDeletedIdsString = (ids: number[] = []) =>
  `${ScopeConfigurationPromptStatus.DELETED}=${getJoinedIdsString(ids)}`
export const getAddedIdsString = (ids: number[] = []) =>
  `${ScopeConfigurationPromptStatus.ADDED}=${getJoinedIdsString(ids)}`

export const getSectionNameString = (question: ScenarioQuestion, defaultValue = '') => {
  const sectionName = question?.deliverablePrompt?.scopeSectionName
  return sectionName ? `,sectionName=${sectionName}` : defaultValue
}

/** Added/Deleted ids mappers */
export const getIdsString = (value: string): string => {
  const parts = value?.split(',') || []
  const idParts = getIds(parts)
  return getJoinedIdsString(idParts)
}

export const getIds = (parts): number[] => {
  const stopIndex = parts.findIndex((part) => part.startsWith('sectionName=') || part.startsWith('deleted='))
  const idParts = stopIndex >= 0 ? parts.slice(0, stopIndex) : parts
  return idParts
    .map((p) => p.trim())
    .filter((p) => p.length > 0)
    .map((p) => +p)
}

export const getDeletedIds = (parts: string[]) => {
  const delIndex = parts.findIndex((p) => p.startsWith(`${ScopeConfigurationPromptStatus.DELETED}=`))
  if (delIndex === -1) return []
  const addIndex = parts.findIndex((p) => p.startsWith(`${ScopeConfigurationPromptStatus.ADDED}=`))
  const endIndex = addIndex > -1 ? addIndex : parts.length
  const delBlock = parts.slice(delIndex, endIndex)

  return mapIdsArray(delBlock, ScopeConfigurationPromptStatus.DELETED)
}

export const getAddedIds = (parts: string[]): number[] => {
  const addIndex = parts.findIndex((p) => p.startsWith(`${ScopeConfigurationPromptStatus.ADDED}=`))
  if (addIndex === -1) return []
  const addBlock = parts.slice(addIndex)

  return mapIdsArray(addBlock, ScopeConfigurationPromptStatus.ADDED)
}

export const getAllIds = (ids: string): number[] => {
  if (typeof ids !== 'string') return []

  const selectedIdsArray = ids?.split(',') || []

  const selectedIds = getIds(selectedIdsArray)
  const addedIds = getAddedIds(selectedIdsArray)
  const deletedIds = getDeletedIds(selectedIdsArray)

  return union(selectedIds, addedIds, deletedIds)
}

export const mapIdsArray = (block, status: ScopeConfigurationPromptStatus) => {
  return block
    .map((p, i) => (i === 0 ? p.substring(`${status}=`.length) : p))
    .map((p) => Number(p.trim()))
    .filter((p) => p && p !== '')
}
/** end Added/Deleted ids mappers */

export const getConcatenatedFeePromptString = (value: string, ids: string, question: ScenarioQuestion) => {
  const isScopeFee = !question.deliverablePrompt?.deliverablePromptOptions?.length

  return [value, ids].join(value && ids && !isScopeFee ? PROMPT_SEPARATOR : '')
}
